<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar motivo de cese" : "Nuevo motivo de cese" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos del motivo' : 'Datos del nuevo motivo'">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-select
              label="Tipo de cese"
              required
              :items="typeOptions"
              v-model="form.terminationType"
              defaultOption="Seleccionar tipo"
              :error="$v.form.terminationType.$error && !$v.form.terminationType.required ? 'El tipo de cese es requerido' : ''"
              @change="onTypeChange"
            />
          </div>
          <div class="w-full md:w-1/2 mb-3 px-2">
            <wz-input
              label="Motivo de cese"
              required
              v-model="form.name"
              placeholder="Descripción completa del motivo"
              :error="$v.form.name.$error && !$v.form.name.required ? 'El motivo de cese es requerido' : ''"
            />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button variant="light" @click="$router.push({ name: 'cessation-reason-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { required } from 'vuelidate/lib/validators'
import { CessationReasonService } from '@/core/services'

export default {
  data() {
    return {
      editing: false,
      form: { terminationType: null, name: null, shortDescription: null, tregistroCode: null },
      typeOptions: [],
    }
  },
  validations: { form: { terminationType: { required }, name: { required } } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        const data = { terminationType: this.form.terminationType, name: this.form.name, shortDescription: this.form.shortDescription, tregistroCode: this.form.tregistroCode }
        if (!this.editing) await CessationReasonService.save(data)
        else await CessationReasonService.update(this.$route.params.id, data)
        Alert.success('Se almacenó la información correctamente')
        this.$router.push({ name: 'cessation-reason-list' })
      } catch (ex) {
        console.error(ex)
        Alert.error(ex.errors ? ex.errors.message : 'Error al guardar')
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const p = (await CessationReasonService.get(id)).payload
        this.form = { terminationType: p.terminationType, name: p.name, shortDescription: p.shortDescription, tregistroCode: p.tregistroCode }
        this.editing = true
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al cargar')
        this.$router.push({ name: 'cessation-reason-list' })
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async loadTypes() {
      try {
        this.typeOptions = (await CessationReasonService.listTypes()).payload || []
      } catch (e) {
        console.error(e)
      }
    },
    // Al elegir un tipo (interacción del usuario), autocompletar código y
    // descripción abreviada desde el catálogo. En el load de edición no se
    // dispara (@change solo corre por selección manual), preservando lo de BD.
    onTypeChange(key) {
      const selected = key != null ? key : this.form.terminationType
      const tipo = this.typeOptions.find(t => t.key === selected)
      this.form.tregistroCode = tipo ? tipo.code : null
      this.form.shortDescription = tipo ? tipo.label : null
    },
  },
  async created() {
    await this.loadTypes()
    if (this.$route.params.id) this.load(this.$route.params.id)
  },
}
</script>
